import React from 'react';
import './OrderSkeleton.css';

interface OrderSkeletonProps {
  className?: string;
}

export const OrderSkeleton: React.FC<OrderSkeletonProps> = ({ className }) => {
  return (
    <div className={`order-skeleton ${className || ''}`}>
      {/* Store Header Skeleton */}
      <div className="skeleton-store-header">
        <div className="skeleton-line skeleton-store-name"></div>
        <div className="skeleton-line skeleton-store-address"></div>
        <div className="skeleton-line skeleton-store-phone"></div>
      </div>

      {/* Order Header Skeleton */}
      <div className="skeleton-order-header">
        <div className="skeleton-order-info">
          <div className="skeleton-line skeleton-order-title"></div>
          <div className="skeleton-line skeleton-order-date"></div>
          <div className="skeleton-line skeleton-order-type"></div>
        </div>
        <div className="skeleton-status"></div>
      </div>

      {/* Items Header Skeleton */}
      <div className="skeleton-items-header">
        <div className="skeleton-line skeleton-items-title"></div>
      </div>

      {/* Item Skeleton */}
      <div className="skeleton-item">
        <div className="skeleton-item-details">
          <div className="skeleton-line skeleton-item-name"></div>
          <div className="skeleton-line skeleton-item-brand"></div>
          <div className="skeleton-line skeleton-item-weight"></div>
          <div className="skeleton-line skeleton-item-price"></div>
        </div>
        <div className="skeleton-item-summary">
          <div className="skeleton-line skeleton-quantity"></div>
          <div className="skeleton-line skeleton-total"></div>
        </div>
      </div>

      {/* Order Summary Skeleton */}
      <div className="skeleton-summary">
        <div className="skeleton-line skeleton-summary-title"></div>
        <div className="skeleton-summary-row">
          <div className="skeleton-line skeleton-label"></div>
          <div className="skeleton-line skeleton-value"></div>
        </div>
        <div className="skeleton-summary-row">
          <div className="skeleton-line skeleton-label"></div>
          <div className="skeleton-line skeleton-value"></div>
        </div>
        <div className="skeleton-summary-total">
          <div className="skeleton-line skeleton-total-label"></div>
          <div className="skeleton-line skeleton-total-value"></div>
        </div>
      </div>

      {/* Payment Method Skeleton */}
      <div className="skeleton-payment">
        <div className="skeleton-line skeleton-payment-label"></div>
        <div className="skeleton-line skeleton-payment-value"></div>
      </div>
    </div>
  );
};

export default OrderSkeleton;